<template>
    <div>
        <div class="alert alert-warning" role="alert">
            3/31(月)21:00以降をもって外航貨物保険の新規付保は受付停止となりました。
        </div>

        <GridPage
            ref="gridPage"
            :form-default="{
                items: [],
                status: 'draft',
            }"
            :filters-default="{
                status: '',
                shipping_tracking_confirmed_at: '',
                sort: '-shipping_tracking_confirmed_at',
            }"
            :filter-items="[
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: '登録済', value: 'draft' },
                        { text: '有効確認済', value: 'activated' },
                        { text: '無効', value: 'error_timeout,error_invalid' },
                    ],
                },
                {
                    vModel: 'shipping_tracking_confirmed_at',
                    title: '追跡有効確認日時',
                    type: 'date-range',
                    options: {
                        force_range: false,
                    },
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 追跡有効確認日時', value: 'shipping_tracking_confirmed_at', },
                        { text: '▼ 追跡有効確認日時', value: '-shipping_tracking_confirmed_at' },
                    ],
                },
            ]"
            filters-q-placeholder="氏名、会社名、メール、電話、Tuskey保険番号"
            form-modal-id="insurance"
            search-action="insurance/index"
            :filter-search-results="filterSearchResults"
            row-class="flex-nowrap mx-0 my--2"
            :hide-download="false"
            :hide-table="true"
            :hide-add="true"
            :open-detail-after-saving="false"
            item-id="id"
            @after-save="afterSave"
            @after-destroy="afterDestroy"
            >
            <template v-slot:form="{ form, init }">
                <Insurance
                    :model="form"
                    :init="init"
                    @save="$refs.gridPage.save"
                    @destroy="$refs.gridPage.destroy"
                    />
            </template>

            <template v-slot:search-append="{ form, init }">
                <b-input-group-append
                    v-if="auth_level >= '300'"
                    >
                    <b-button type="button" @click="downloadInvoices">
                        <font-awesome-icon icon="file-invoice-dollar" />
                    </b-button>
                </b-input-group-append>
            </template>

            <template v-slot:before-filter>
            </template>

            <template v-slot:after-table>
                <InsuranceTable ref="table" mode="read" @on-detail="onDetail" />
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Insurance from '@/components/Insurance.vue'
import ShippingBadges from '@/components/ShippingBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import ItemInfo from '@/components/ItemInfo.vue'
import InsuranceTable from '@/components/InsuranceTable.vue'

export default {
    components: {
        GridPage,
        Insurance,
        ShippingBadges,
        ItemThumb,
        ItemInfo,
        InsuranceTable,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {
//            table: null,
        }
    },
    methods: {
        filterSearchResults(response) {
            if (response.data && response.data.hits) {
                this.$refs.table.loadData(response.data.hits)
            } else {
                this.$refs.table.loadData([])
            }
            this.$refs.table.setup()
            return response
        },
        afterSave() {
            this.$refs.gridPage.search()
            this.$store.dispatch('notification/push', { color: 'success', life: 25, text: '越境EC用外航貨物保険が登録されました。ご利用ありがとうございます。', })
        },
        afterDestroy() {
            this.$refs.gridPage.search()
        },
        onDetail(item) {
            this.$refs.gridPage.detail(item)
        },
        downloadInvoices() {
            this.$utils.set(this.$refs.gridPage.grid.filters, { download_invoices: 1, })
            this.$refs.gridPage.download(event)
            this.$delete(this.$refs.gridPage.grid.filters, 'download_invoices')
        },
    },
    mounted () {
        if (this.auth_level === '001') {
            this.$refs.gridPage.grid.filters.status = 'activated'
        }
    },
}
</script>

<style lang="scss">
</style>

